import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { TransitTimes } from 'contracts/TransitTimes';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_TRANSITTIME_',
  }
);

export interface ListTransitTimesState {
  data: TransitTimes[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListTransitTimesRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: TransitTimes[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListTransitTimesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListTransitTimesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListTransitTimesState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListTransitTimesState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListTransitTimesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listTransitTimes = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListTransitTimesTypes = Types;
export const ListTransitTimesActions = Creators;
